// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__140nY","left":"styles_left__1i9KC"};